import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'
import IconTier from '@/features/tickets/assets/IconTier.vue'
import { ITicketPurchased } from '@/features/tickets/types'
import { computed, ref } from 'vue'
import { useImage } from '@/shared/composables/image'
import AvatarPlaceholder from '@/features/tickets/assets/AvatarPlaceholder.vue'
import { mdiCheck, mdiDotsHorizontal } from '@mdi/js'
import BKConfirmationDialog from '@/shared/ui/modals/BKConfirmationDialog.vue'
import {
  useCheckInTicketMutation,
  useRemoveTicketMutation,
  useUncheckTicketMutation,
} from '@/features/tickets/api/queries'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectedTicketAdmin',
  props: {
    ticket: null
  },
  emits: ["show-assignment-interface", "show-tier-change-interface", "show-refund-interface", "show-receipt-interface"],
  setup(__props: any) {

const props = __props as {
  ticket: ITicketPurchased
};

// @ts-expect-error Not a ts file




const getUserDB = computed(() => store.getters.getUserDB)
const { getImageById } = useImage()
const { mutate: checkInTicket, isPending: isCheckingIn, error: checkInError } = useCheckInTicketMutation()
const { mutate: uncheckTicket, isPending: isUnchecking, error: uncheckError } = useUncheckTicketMutation()
const { mutate: removeTicket, isPending: isRemoving, error: removeError } = useRemoveTicketMutation()

const actionError = computed(() => checkInError.value || uncheckError.value || removeError.value)

const showUncheckConfirm = ref(false)
const showRemoveConfirm = ref(false)

const checkInTicketHandler = async () => {
  if (isCheckingIn.value) return
  checkInTicket(props.ticket.id)
}

const confirmUncheck = () => {
  showUncheckConfirm.value = false
  if (isUnchecking.value) return
  uncheckTicket(props.ticket.id)
}

const confirmRemove = () => {
  showRemoveConfirm.value = false
  if (isRemoving.value) return
  removeTicket(props.ticket.id)
}

return { __sfc: true,props, getUserDB, getImageById, checkInTicket, isCheckingIn, checkInError, uncheckTicket, isUnchecking, uncheckError, removeTicket, isRemoving, removeError, actionError, showUncheckConfirm, showRemoveConfirm, checkInTicketHandler, confirmUncheck, confirmRemove, IconTier, AvatarPlaceholder, mdiCheck, mdiDotsHorizontal, BKConfirmationDialog }
}

})